import { render, staticRenderFns } from "./ContactsAdditionsByMonth.vue?vue&type=template&id=4516560e&"
import script from "./ContactsAdditionsByMonth.vue?vue&type=script&lang=js&"
export * from "./ContactsAdditionsByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports